export enum BtmReturnRequestServiceWindow {
    Unknown = "Unknown",
    Morning = "Morning",
    Noon = "Noon",
    Afternoon = "Afternoon",
    Evening = "Evening",
}

export const BuildBtmReturnRequestServiceWindowFromString = (serviceWindow: string) => {
    switch (serviceWindow) {
        case "Morning":
            return BtmReturnRequestServiceWindow.Morning;
        case "Noon":
            return BtmReturnRequestServiceWindow.Noon;
        case "Afternoon":
            return BtmReturnRequestServiceWindow.Afternoon;
        case "Evening":
            return BtmReturnRequestServiceWindow.Evening;
        default:
            return undefined;
    }
};
